// Sri Lanka districts with approximate coordinates for heat map
export const sriLankaDistricts = [
  { name: 'Colombo', lat: 6.9271, lon: 79.8612, intensity: 0.8 },
  { name: 'Gampaha', lat: 7.0908, lon: 80.0147, intensity: 0.7 },
  { name: 'Kalutara', lat: 6.5854, lon: 80.1423, intensity: 0.9 },
  { name: 'Kandy', lat: 7.2906, lon: 80.6337, intensity: 0.6 },
  { name: 'Matale', lat: 7.4686, lon: 80.6237, intensity: 0.5 },
  { name: 'Nuwara Eliya', lat: 6.9497, lon: 80.7891, intensity: 0.4 },
  { name: 'Galle', lat: 6.0535, lon: 80.2210, intensity: 0.8 },
  { name: 'Matara', lat: 5.9549, lon: 80.5550, intensity: 0.7 },
  { name: 'Hambantota', lat: 6.1429, lon: 81.1212, intensity: 0.6 },
  { name: 'Jaffna', lat: 9.6615, lon: 80.0255, intensity: 0.3 },
  { name: 'Kilinochchi', lat: 9.3964, lon: 80.3987, intensity: 0.4 },
  { name: 'Mannar', lat: 8.9810, lon: 79.9044, intensity: 0.5 },
  { name: 'Vavuniya', lat: 8.7542, lon: 80.4982, intensity: 0.4 },
  { name: 'Mullaitivu', lat: 9.2671, lon: 80.8142, intensity: 0.3 },
  { name: 'Batticaloa', lat: 7.7170, lon: 81.6937, intensity: 0.6 },
  { name: 'Ampara', lat: 7.2916, lon: 81.6727, intensity: 0.7 },
  { name: 'Trincomalee', lat: 8.5874, lon: 81.2152, intensity: 0.5 },
  { name: 'Kurunegala', lat: 7.4818, lon: 80.3609, intensity: 0.6 },
  { name: 'Puttalam', lat: 8.0360, lon: 79.8283, intensity: 0.7 },
  { name: 'Anuradhapura', lat: 8.3114, lon: 80.4037, intensity: 0.5 },
  { name: 'Polonnaruwa', lat: 7.9403, lon: 81.0188, intensity: 0.4 },
  { name: 'Badulla', lat: 6.9934, lon: 81.0550, intensity: 0.5 },
  { name: 'Moneragala', lat: 6.8728, lon: 81.3507, intensity: 0.6 },
  { name: 'Ratnapura', lat: 6.6828, lon: 80.4017, intensity: 0.8 },
  { name: 'Kegalle', lat: 7.2513, lon: 80.3464, intensity: 0.7 },
];

// Sri Lanka boundary coordinates (simplified)
export const sriLankaBoundary = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: { name: 'Sri Lanka' },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [79.7, 9.9],
            [81.9, 9.9],
            [82.0, 7.5],
            [81.8, 6.0],
            [80.3, 5.9],
            [79.5, 6.5],
            [79.4, 8.5],
            [79.7, 9.9],
          ],
        ],
      },
    },
  ],
};

export const getHeatMapData = () => {
  return sriLankaDistricts.map((district) => [
    district.lat,
    district.lon,
    district.intensity,
  ]);
};
